import { sbaAxios } from "../utils/sbaAxios";
import {
  FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN,
  FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS,
  FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE,

  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN,
  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS,
  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE,

} from "../constants/privateExposure";
import { getPrivateExposureAssetData, getPrivateExposureCategoryTypeDates } from "../../config/apiConfig";

//8
export const getExposureAssetLevelChartAction = (
  startDate,
  endDate,
  assetId,
  ExposureCategoryTypeId,
  isStandardSector
) => {
    return async (dispatch) => {
        if (startDate == "Invalid date") {
            //dispatch(getExposureAssetChartActionFailure());
        }
        else {
            console.log(startDate, "min startdate 7");
            dispatch(getExposureAssetChartActionBegin());
            try {
                const response = await sbaAxios({
                    url: `${getPrivateExposureAssetData}${startDate}/${endDate}/${assetId}/${ExposureCategoryTypeId}/${isStandardSector}`,
                    method: 'get',
                })
                const AssetLevelChart = response;
                dispatch(getExposureAssetLevelChartSuccess(AssetLevelChart));
            } catch (error) {
                if (error.message === "Network Error") {
                    dispatch(getExposureAssetLevelChartSuccess({}));
                } else {
                    dispatch(getExposureAssetChartActionFailure(error));
                }
            }
        }
  };
};

export const getExposureAssetLevelChartSuccess = (AssetLevelChart) => ({
  type: FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS,
  payload: { AssetLevelChart },
});

export const getExposureAssetChartActionBegin = () => ({
  type: FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN,
});

export const getExposureAssetChartActionFailure = (errorMessage) => ({
  type: FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE,
  payload: { errorMessage },
});


export const getPrivateExposureCategoryTypeDatesAction = (AssetID) => {
    return async (dispatch) => {
        dispatch(getPrivateExposureCategoryTypeDatesActionBegin());
        try {
            const response = await
                sbaAxios({
                    url: `${getPrivateExposureCategoryTypeDates}${AssetID}`,
                    method: 'get',
                })
            const CategoryTypeDates = response;
            dispatch(getPrivateExposureCategoryTypeDatesSuccess(CategoryTypeDates));
        } catch (error) {
            if (error.message === "Network Error") {
                dispatch(getPrivateExposureCategoryTypeDatesSuccess({}));
            } else {
                dispatch(getPrivateExposureCategoryTypeDatesActionFailure(error));
            }
        }
    };
};

export const getPrivateExposureCategoryTypeDatesSuccess = (CategoryTypeDates) => ({
    type: FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS,
    payload: { CategoryTypeDates },
});
export const getPrivateExposureCategoryTypeDatesActionBegin = () => ({
    type: FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN,
});

export const getPrivateExposureCategoryTypeDatesActionFailure = (errorMessage) => ({
    type: FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE,
    payload: { errorMessage },
});